// import { EditNoteOutlined } from "@mui/icons-material";
import {
  Grid,
  //   IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, Fragment } from "react";
import { IAdminLog } from "../../../interface/IAdminLog";
// import { DeletePostModal } from "../modal-delete";

const rowStyles: React.CSSProperties = {
  textAlign: "center",
  padding: "10px",
  fontWeight: "bold",
};

export const ErrorLogsTable: FC<IAdminLog> = ({
  logs,
  getUserId,
  getDeleteUserId,
}) => {
  //   const handleUserClick = (userId: string) => {
  //     getUserId(userId);
  //   };

  //   const handleDeleteUser = (userId: string) => {
  //     getDeleteUserId(userId);
  //   };
  return (
    <Fragment>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={rowStyles}>Modul</TableCell>
            <TableCell style={rowStyles}>Beschreibung</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(logs) &&
            logs.map((itemLog) => (
              <TableRow key={itemLog._id}>
                <TableCell align="center">{itemLog.module}</TableCell>
                <TableCell align="center">{itemLog.description}</TableCell>

                <TableCell align="center">
                  <Grid
                    container
                    spacing={2}
                    display="flex"
                    justifyContent="center"
                  >
                    {/* <Grid
                      item
                      display="flex"
                      justifyContent="center"
                      alignItems="end"
                    >
                      <IconButton onClick={() => handleUserClick(itemLog._id)}>
                        <EditNoteOutlined
                          sx={{
                            fontWeight: "bold",
                            color: "black",
                          }}
                        />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <DeletePostModal
                        onDelete={() => handleDeleteUser(itemLog._id)}
                      />
                    </Grid> */}
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Fragment>
  );
};
